import styled from "styled-components";

import { chatColors } from "./chatColors";

export const StyledMain = styled.main`
  width: 100%;
  background: ${chatColors.mainBackground};
  box-sizing: border-box;
  display: flex;
  flex-direction: column-reverse;

  padding: 1rem 0;
`;

export const StyledDisplayAreaDiv = styled.div`
  padding: 10px 10px 0 10px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  flex-basis: auto;
  gap: 0.5rem;
`;
